import css from 'styled-jsx/css';

const styles = css.global`.games-mobile-dropdown-controls{display:flex;flex-direction:row;justify-content:space-between;margin-right:8px;gap:5px}.games-mobile-dropdown-controls .toggle-button{width:39px;height:26px;border-radius:4px;cursor:pointer;font-size:1px}`;

export default styles;